<template>
  <v-card>
    <!-- <v-card-title>User Login</v-card-title> -->
    <v-list>
      <v-list-tile avatar>
        <v-list-tile-avatar>
          <v-icon large>add</v-icon>
        </v-list-tile-avatar>

        <v-list-tile-content>
          <v-list-tile-title>Add New Agent</v-list-tile-title>
        </v-list-tile-content>

        <v-list-tile-action>
          <v-btn icon fav small outline @click="onCancelled">
            <v-icon>clear</v-icon>
          </v-btn>
        </v-list-tile-action>
      </v-list-tile>
    </v-list>
    <v-divider></v-divider>
    <v-card-text style="max-height: 85%">
      <v-form ref="addAgentForm" v-model="valid" lazy-validation>
        <v-layout column>
          <!-- <v-flex
            xs12
            class="text-xs-center text-sm-center text-md-center text-lg-center"
          >
            <img :src="imageUrl" height="150" v-if="imageUrl" />
            <v-text-field
              label="Select Image"
              @click="pickFile"
              v-model="imageName"
              prepend-icon="attach_file"
            ></v-text-field>
            <input
              type="file"
              style="display: none"
              ref="image"
              accept="image/*"
              @change="onFilePicked"
            />
          </v-flex> -->

          <v-flex xs12>
            <v-layout row wrap>
              <v-flex md4>
                <v-text-field
                  outline
                  label="Full Name *"
                  required
                  v-model="newItem.name"
                  :rules="requiredRules"
                ></v-text-field>
              </v-flex>
              <v-flex md4 pl-1>
                <v-text-field
                  outline
                  label="Father's Name *"
                  required
                  v-model="newItem.father_name"
                  :rules="requiredRules"
                ></v-text-field>
              </v-flex>
              <v-flex md4 pl-1>
                <v-text-field
                  outline
                  label="Mother's Name"
                  v-model="newItem.mother_name"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12> Present Address: </v-flex>
          <v-flex xs12>
            <v-layout>
              <v-flex md3>
                <v-autocomplete
                  label="District *"
                  v-model="newItem.present_district"
                  :items="districtTV()"
                  hide-details
                  hide-selected
                  item-text="text"
                  item-value="value"
                  outline
                  required
                  :rules="requiredRules"
                >
                </v-autocomplete>
              </v-flex>
              <v-flex md3 pl-1>
                <v-autocomplete
                  label="PS *"
                  v-model="newItem.present_upazila"
                  :items="upazilaTV(newItem.present_district)"
                  hide-details
                  hide-selected
                  item-text="text"
                  item-value="value"
                  outline
                  required
                  :rules="requiredRules"
                >
                </v-autocomplete>
              </v-flex>
              <v-flex md3 pl-1>
                <v-autocomplete
                  label="P.O *"
                  v-model="newItem.present_union"
                  :items="unionTV(newItem.present_upazila)"
                  hide-details
                  hide-selected
                  item-text="text"
                  item-value="value"
                  outline
                  required
                  :rules="requiredRules"
                >
                </v-autocomplete>
              </v-flex>
              <v-flex md3 pl-1>
                <v-text-field
                  outline
                  label="Vill *"
                  required
                  v-model="newItem.present_village"
                  :rules="requiredRules"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12> Permanent Address: </v-flex>
          <v-flex xs12>
            <v-layout pb-1>
              <v-flex md3>
                <v-autocomplete
                  label="District"
                  v-model="newItem.permanent_district"
                  :items="districtTV()"
                  hide-details
                  hide-selected
                  item-text="text"
                  item-value="value"
                  outline
                >
                </v-autocomplete>
              </v-flex>
              <v-flex md3 pl-1>
                <v-autocomplete
                  label="PS"
                  v-model="newItem.permanent_upazila"
                  :items="upazilaTV(newItem.permanent_district)"
                  hide-details
                  hide-selected
                  item-text="text"
                  item-value="value"
                  outline
                >
                </v-autocomplete>
              </v-flex>
              <v-flex md3 pl-1>
                <v-autocomplete
                  label="P.O"
                  v-model="newItem.permanent_union"
                  :items="unionTV(newItem.permanent_upazila)"
                  hide-details
                  hide-selected
                  item-text="text"
                  item-value="value"
                  outline
                >
                </v-autocomplete>
              </v-flex>
              <v-flex md3 pl-1>
                <v-text-field
                  outline
                  label="Vill"
                  v-model="newItem.permanent_village"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12>
            <v-layout row wrap>
              <v-flex md6 class="pr-1">
                <v-menu
                  v-model="dobDateMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="newItem.dob"
                      label="Date of birth"
                      readonly
                      outline
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="newItem.dob"
                    @input="dobDateMenu = false"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xs6>
                <v-text-field outline label="Age" v-model="newItem.age"></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12>
            <v-layout row wrap>
              <v-flex md6 class="pr-1">
                <v-text-field
                  outline
                  label="NID Number *"
                  v-model="newItem.nid_number"
                  required
                  :rules="requiredRules"
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-autocomplete
                  label="Nationality *"
                  v-model="newItem.nationality"
                  :items="NATIONALITIES"
                  hide-details
                  hide-selected
                  outline
                  required
                  :rules="requiredRules"
                >
                </v-autocomplete>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex xs12>
            <v-layout row wrap pb-4>
              <v-flex md6 pr-1>
                <v-autocomplete
                  label="Gender *"
                  v-model="newItem.gender"
                  :items="GENDERS"
                  hide-details
                  hide-selected
                  outline
                  required
                  :rules="requiredRules"
                >
                </v-autocomplete>
              </v-flex>
              <v-flex xs6>
                <v-autocomplete
                  label="Religion *"
                  v-model="newItem.religion"
                  :items="getTV(RELIGIONS)"
                  hide-details
                  hide-selected
                  outline
                  required
                  :rules="requiredRules"
                >
                </v-autocomplete>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex xs12>
            <v-layout row wrap>
              <v-flex md4>
                <v-text-field
                  outline
                  label="Mobile Number *"
                  v-model="newItem.mobile"
                  required
                  :rules="requiredRules"
                ></v-text-field>
              </v-flex>
              <v-flex md4 pl-1>
                <v-text-field
                  outline
                  label="Emergency Contact *"
                  v-model="newItem.emergency_contact"
                  required
                  :rules="requiredRules"
                ></v-text-field>
              </v-flex>
              <v-flex md4 pl-1>
                <v-text-field
                  outline
                  label="Relation *"
                  v-model="newItem.emergency_relation"
                  required
                  :rules="requiredRules"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12>
            <v-layout row wrap>
              <v-flex md4>
                <v-text-field
                  outline
                  label="Office/Comapny name"
                  v-model="newItem.company_name"
                ></v-text-field>
              </v-flex>
              <v-flex md4 pl-1>
                <v-text-field
                  outline
                  label="Staff Mobile No"
                  v-model="newItem.company_staff_contact"
                ></v-text-field>
              </v-flex>
              <v-flex md4 pl-1>
                <v-text-field
                  outline
                  label="Email"
                  v-model="newItem.email"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
          <!-- <v-flex xs -->
          <v-textarea v-model="newItem.notes" outline label="Notes"></v-textarea>
        </v-layout>
      </v-form>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn @click="onCancelled">Cancel</v-btn>
      <v-btn
        color="blue"
        @click="newItemDo"
        :disabled="!valid || actionButtonClicked"
        :loading="actionButtonClicked"
        >Add</v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script>
import { GENDERS, NATIONALITIES, RELIGIONS } from "../../mdsir/const";
import { getTV, districtTV, upazilaTV, unionTV } from "../../mdsir/MdsirUtils";
export default {
  data() {
    return {
      actionButtonClicked: false,
      valid: true,
      newItem: {
        name: "",
        father_name: "",
        mother_name: "",
        present_district: "",
        present_upazila: "",
        present_union: "",
        present_village: "",
        permanent_district: "",
        permanent_upazila: "",
        permanent_union: "",
        permanent_village: "",
        dob: "",
        age: "",
        nid_number: "",
        // nationality: "Bangladeshi",
        nationality: "",
        gender: "",
        religion: "",
        mobile: "",
        emergency_contact: "",
        emergency_relation: "",
        company_name: "",
        company_staff_contact: "",
        email: "",
        notes: "",
        // address: "",
      },
      dobDateMenu: false,
      NATIONALITIES: NATIONALITIES,
      RELIGIONS: RELIGIONS,
      GENDERS: GENDERS,
      imageName: "",
      imageUrl: "",
      imageFile: "",
    };
  },
  methods: {
    onCancelled() {
      this.$emit("cancelled");
    },
    onNewItemAdded(addedData) {
      this.$emit("added", addedData);
      this.clearForm();
      this.onCancelled();
    },
    validate() {
      if (this.$refs.addAgentForm.validate()) {
        this.snackbar = true;
      }
    },
    reset() {
      this.$refs.addAgentForm.reset();
    },
    resetValidation() {
      this.$refs.addAgentForm.resetValidation();
    },
    clearForm() {
      this.newItem = {
        name: "",
        father_name: "",
        mother_name: "",
        present_district: "",
        present_upazila: "",
        present_union: "",
        present_village: "",
        permanent_district: "",
        permanent_upazila: "",
        permanent_union: "",
        permanent_village: "",
        dob: "",
        age: "",
        nid_number: "",
        // nationality: "Bangladeshi",
        nationality: "",
        gender: "",
        religion: "",
        mobile: "",
        emergency_contact: "",
        emergency_relation: "",
        company_name: "",
        company_staff_contact: "",
        email: "",
        notes: "",
        // address: "",
      };
    },
    newItemDo() {
      if (this.$refs.addAgentForm.validate()) {
        this.actionButtonClicked = true;
        this.post("/agent", this.newItem).then((res) => {
          if (res.data.success) {
            this.onNewItemAdded(res.data.data);
          }
          this.snackbarShow(res.data);
          this.actionButtonClicked = false;
        });
      }
    },
    districtTV: districtTV,
    upazilaTV: upazilaTV,
    unionTV: unionTV,
    getTV: getTV,

    pickFile() {
      this.$refs.image.click();
    },

    onFilePicked(e) {
      const files = e.target.files;
      if (files[0] !== undefined) {
        this.imageName = files[0].name;
        if (this.imageName.lastIndexOf(".") <= 0) {
          return;
        }
        const fr = new FileReader();
        fr.readAsDataURL(files[0]);
        fr.addEventListener("load", () => {
          this.imageUrl = fr.result;
          this.imageFile = files[0]; // this is an image file that can be sent to server...
        });
      } else {
        this.imageName = "";
        this.imageFile = "";
        this.imageUrl = "";
      }
    },
  },
  mounted() {},
  created() {
    // this.GENDERS = GENDERS;
  },
};
</script>
